export default function MessagesPanel({ sectionId, messages }) {
  return (
    <section id={sectionId} className="rounded-[32px] border border-white/10 bg-[#111112]/90 p-6 shadow-xl shadow-black/20">
      <div className="mb-5 flex items-center justify-between gap-4">
        <div>
          <p className="text-sm uppercase tracking-[0.35em] text-zinc-500">Contact Messages</p>
          <h2 className="mt-2 text-2xl font-black text-white">رسائل التواصل</h2>
        </div>
        <span className="inline-flex items-center rounded-full bg-[#38bdf8]/10 px-4 py-2 text-xs font-black uppercase tracking-[0.35em] text-[#38bdf8]">
          {messages.length} رسالة
        </span>
      </div>

      <div className="space-y-4">
        {messages.length ? messages.map((message) => (
          <div key={message.id} className="rounded-3xl border border-white/10 bg-[#0b0b0d] p-4">
            <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between text-sm text-zinc-300">
              <span className="font-black text-white">{message.name || "مستخدم"}</span>
              <span>{message.email || "بدون بريد"}</span>
            </div>
            <p className="mt-3 text-sm leading-6 text-zinc-400">{message.message || "لا توجد رسالة"}</p>
          </div>
        )) : (
          <p className="text-sm text-zinc-400">لا توجد رسائل حتى الآن.</p>
        )}
      </div>
    </section>
  );
}
